export const getValidPage = ({ current, totalPages }) =>
  Number(current) > 0 && current <= totalPages ? current : 1
